import { Functionality, Action } from "./functionality";

export abstract class FunctionalityValidator {
  abstract canAccess(feature: Functionality, ...actions: Action[]): boolean;
}
